import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main/Main'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    meta: {
      title: 'Home Page - Example App',
      metaTags: [
        {
          name: 'description',
          content: 'ID4Good is one of the innovative features from Bloqs4Good. B4G is an ecosystem built on cutting edge technology, where an individuals privacy and personal information security is paramount. Our ecosystem4Good powers many wonderful experiences as well as helping SME\'s compete in the new economy coming.'
        },
        {
          property: 'og:description',
          content: 'ID4Good is one of the innovative features from Bloqs4Good. B4G is an ecosystem built on cutting edge technology, where an individuals privacy and personal information security is paramount. Our ecosystem4Good powers many wonderful experiences as well as helping SME\'s compete in the new economy coming.'
        },
        {
          name: 'title',
          content: 'Id4Good, We founded our company on the value of privacy and security, with this APP we create a new path towards freedom of choice'
        }
      ]
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
